import React from 'react';
import { Business, BusinessBranding } from '../types';
import { CookieSettingsLink } from './CookieConsentBanner';

interface BusinessFooterProps {
  business: Business;
  branding?: BusinessBranding;
  className?: string;
}

const BusinessFooter: React.FC<BusinessFooterProps> = ({ 
  business, 
  branding,
  className = ''
}) => {
  const surfaceColor = '#ffffff';
  const borderColor = branding?.accentColor ? `${branding.accentColor}40` : '#f5c2cc';
  const textColor = branding?.textColor || '#111827';
  const mutedColor = branding?.textColor ? `${branding.textColor}80` : '#6b7280';

  return (
    <footer 
      className={`mt-10 pt-4 pb-5 ${className}`}
      style={{
        backgroundColor: surfaceColor,
        borderTop: `1px solid ${borderColor}`
      }}
    >
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between items-center gap-2">
        {(business.instagramUrl || business.facebookUrl || business.youtubeUrl) && (
          <div className="flex gap-2">
            {business.instagramUrl && (
              <a
                href={business.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border inline-flex items-center justify-center transition-colors hover:opacity-80"
                style={{
                  borderColor: '#e5e7eb',
                  backgroundColor: '#f9fafb',
                  color: textColor
                }}
                aria-label="Instagram"
              >
                <i className="bi bi-instagram"></i>
              </a>
            )}
            {business.facebookUrl && (
              <a
                href={business.facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border inline-flex items-center justify-center transition-colors hover:opacity-80"
                style={{
                  borderColor: '#e5e7eb',
                  backgroundColor: '#f9fafb',
                  color: textColor
                }}
                aria-label="Facebook"
              >
                <i className="bi bi-facebook"></i>
              </a>
            )}
            {business.youtubeUrl && (
              <a
                href={business.youtubeUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-8 h-8 rounded-full border inline-flex items-center justify-center transition-colors hover:opacity-80"
                style={{
                  borderColor: '#e5e7eb',
                  backgroundColor: '#f9fafb',
                  color: textColor
                }}
                aria-label="YouTube"
              >
                <i className="bi bi-youtube"></i>
              </a>
            )}
          </div>
        )}
        <div className={`text-xs text-center ${(business.instagramUrl || business.facebookUrl || business.youtubeUrl) ? '' : 'w-full'}`} style={{ color: mutedColor }}>
          <div>© {new Date().getFullYear()} {business.name}. All rights reserved.</div>
          <div>
            Powered by AACore · A&amp;A Inomatic, LLC ·{' '}
            <a
              href="/privacy"
              className="hover:underline"
              style={{ color: mutedColor }}
            >
              Privacy Policy
            </a>
            {' · '}
            <CookieSettingsLink className="hover:underline" style={{ color: mutedColor }} />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BusinessFooter;